import { useQuery } from '@tanstack/react-query'
import {
  listConsolidatedDcs,
  listDefaultStrategyGroups,
  listMilestones,
  listStockingStrategyCodes,
} from '@/api/cltReference'

const STALE_FOREVER = Infinity

export function useMilestones() {
  return useQuery({
    queryKey: ['milestones'],
    queryFn: listMilestones,
    staleTime: STALE_FOREVER,
  })
}

export function useStockingStrategyCodes() {
  return useQuery({
    queryKey: ['stocking-strategy-codes'],
    queryFn: listStockingStrategyCodes,
    staleTime: STALE_FOREVER,
  })
}

export function useDefaultStrategyGroups() {
  return useQuery({
    queryKey: ['stocking-strategy-codes', 'default-groups'],
    queryFn: listDefaultStrategyGroups,
    staleTime: STALE_FOREVER,
  })
}

export function useConsolidatedDcs() {
  return useQuery({
    queryKey: ['consolidated-dcs'],
    queryFn: listConsolidatedDcs,
    staleTime: STALE_FOREVER,
  })
}
